import { c as _c } from "react/compiler-runtime";
import { useUpdateFunnelStepQuery } from 'modules/funnels/funnel/hooks/use-update-funnel-step-query';
import React from 'react';
import { useLocoTranslation } from 'shared/hooks/use-loco-translation';
import { SplitTestComponentTypeEnum, SplitTestComponentTypeTitles } from '../../enums/split-tests-component-type-enum';
import WebsiteIcon from '../../icons/website-icon';
import { FunnelStepId } from '../../types/funnel-step-interface';
interface SplitTestItemProps {
  type: SplitTestComponentTypeEnum;
  funnelStep: {
    id: FunnelStepId;
    name: string;
  };
  className?: string;
}
function SplitTestItem(t0) {
  const $ = _c(19);
  const {
    type,
    funnelStep,
    className
  } = t0;
  const {
    t
  } = useLocoTranslation();
  const {
    updateFunnelStepQuery
  } = useUpdateFunnelStepQuery();
  let t1;
  if ($[0] !== funnelStep.id || $[1] !== updateFunnelStepQuery) {
    t1 = () => {
      updateFunnelStepQuery(funnelStep.id);
    };
    $[0] = funnelStep.id;
    $[1] = updateFunnelStepQuery;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const handleClick = t1;
  const t2 = `font-inter text-text-primary flex flex-[33_1_0%] flex-col items-center justify-start gap-4 text-xl xl:w-[280px] ${className}`;
  let t3;
  if ($[3] !== handleClick) {
    t3 = <WebsiteIcon className="h-[73px] w-[85px] cursor-pointer lg:h-[104px] lg:w-[121px]" onClick={handleClick} />;
    $[3] = handleClick;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  const t4 = SplitTestComponentTypeTitles[type];
  let t5;
  if ($[5] !== t || $[6] !== t4) {
    t5 = t(t4);
    $[5] = t;
    $[6] = t4;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== t5) {
    t6 = <div className="text-center opacity-60">{t5}</div>;
    $[8] = t5;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  if ($[10] !== funnelStep.name) {
    t7 = <div className="text-center font-bold">{funnelStep.name}</div>;
    $[10] = funnelStep.name;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  let t8;
  if ($[12] !== t6 || $[13] !== t7) {
    t8 = <div className="flex flex-col items-center justify-center gap-1 text-[15px] lg:text-base">{t6}{t7}</div>;
    $[12] = t6;
    $[13] = t7;
    $[14] = t8;
  } else {
    t8 = $[14];
  }
  let t9;
  if ($[15] !== t2 || $[16] !== t3 || $[17] !== t8) {
    t9 = <div className={t2}>{t3}{t8}</div>;
    $[15] = t2;
    $[16] = t3;
    $[17] = t8;
    $[18] = t9;
  } else {
    t9 = $[18];
  }
  return t9;
}
export default SplitTestItem;